<template>
  <material-card>
    <v-layout>
      <v-flex>
        <application-details
          :application="application"
          :title="title"
          :subtitle="subtitle"
          :application-state-text="applicationStateText"
          :hide-show-profile-btn="true"
          :new-card-application="newCardApplication"
        />
      </v-flex>
    </v-layout>
  </material-card>
</template>

<script>
import {
  ApplicationStateTranslation,
  ApplicationTypeTranslation,
  DisplayApplicationState,
  DisplayApplicationType
} from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import ApplicationDetails from '@/components/application/Details';
import MaterialCard from '@/components/material/Card';

// @vuese
// Wyświetlanie zakładki wniosków klienta
// @group Client-Profile
export default {
  components: { MaterialCard, ApplicationDetails },
  computed: {
    ...mapState({
      application: state => state.application.data,
      userId: state => state.application.data.profile.userId
    }),
    title() {
      return `Wniosek numer ${this.application.id}`;
    },
    subtitle() {
      return ApplicationTypeTranslation[DisplayApplicationType[this.application.type]];
    },
    applicationStateText() {
      return ApplicationStateTranslation[DisplayApplicationState[this.application.state]];
    },
    newCardApplication() {
      return this.application.type === 'NEW';
    }
  }
};
</script>
